import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppShell } from "./components/AppShell";
import { RequireAuth } from "./components/RequireAuth";
import { OnboardingGate } from "./components/OnboardingGate";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import { DashboardPage } from "./pages/DashboardPage";
import { SettingsPage } from "./pages/SettingsPage";
import { InboxPage } from "./pages/InboxPage";
import { TeamPage } from "./pages/TeamPage";
import { CustomersPage } from "./pages/CustomersPage";
import { SuppliersPage } from "./pages/SuppliersPage";
import { InvoicesPage } from "./pages/InvoicesPage";
import { BillsPage } from "./pages/BillsPage";
import { BankPage } from "./pages/BankPage";
import { ReportsPage } from "./pages/ReportsPage";
import { SpecPage } from "./pages/SpecPage";
import { EmployeesPage } from "./pages/EmployeesPage";
import { PayrollPage } from "./pages/PayrollPage";
import { UpdatePrompt } from "./components/UpdatePrompt";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UpdatePrompt />
      <BrowserRouter basename="/clearbooks/app">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          <Route
            element={
              <RequireAuth>
                <OnboardingGate>
                  <AppShell />
                </OnboardingGate>
              </RequireAuth>
            }
          >
            <Route path="/onboarding/*" element={<OnboardingPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/suppliers" element={<SuppliersPage />} />
            <Route path="/invoices/*" element={<InvoicesPage />} />
            <Route path="/bills/*" element={<BillsPage />} />
            <Route path="/inbox/*" element={<InboxPage />} />
            <Route path="/bank" element={<BankPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/settings/*" element={<SettingsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/spec" element={<SpecPage />} />
            <Route path="/employees" element={<EmployeesPage />} />
            <Route path="/payroll/*" element={<PayrollPage />} />
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
